export { default } from './modules/JavascriptTimeAgo'

export {
	intlDateTimeFormatSupported as intlDateTimeFormatSupported,
	intlDateTimeFormatSupportedLocale as intlDateTimeFormatSupportedLocale
} from './modules/locale'